import { useEffect, useState } from "react";
import apiPrivateAntesala from "../../../../config/ConfigPrivate";
import { existsEvento } from "../../../../utils/CuponUtils";

const Eventos = ({ cupon, setCupon, setModal }) => {
  const [eventos, setEventos] = useState(null);

  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      const columna1 = response.data?.data?.slice(0, 10) ?? [];
      const columna2 = response.data?.data?.slice(10, 20) ?? [];
      const columna3 = response.data?.data?.slice(20, 30) ?? [];
      setData({ ...response.data, data: { columna1, columna2, columna3 } });
    }
  };

  const onClick = (e, value) => {
    switch (e.target.name) {
      case "añadir-evento":
        {
          if (cupon.eventos.filter((e) => e.id == value.id).length > 0) {
            return "";
          }

          let cuponEventos = cupon.eventos;
          cuponEventos.push(value);

          setCupon({
            ...cupon,
            eventos: cuponEventos,
          });
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    fetch(
      setEventos,
      {
        status: 1,
        sort: "-id",
        per_page: 50,
      },
      `/eventos`
    );
  }, []);
  return (
    <div
      class="modal d-block effect-blur  bg-dark bg-opacity-25 align-middle"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      style={{ zIndex: 104 }}
    >
      <div
        class="bg-light modal-dialog animation-modal my-md-5  overflow-hidden texto-normal"
        style={{ maxWidth: "1100px!important;" }}
      >
        <div className="modal-content bg-light">
          <div class="title m-0 bg-white p-4 d-flex justify-content-between">
            <div>
              <h2>Eventos</h2>
              <span class="fs-6 text-muted"></span>
            </div>
            <div>
              <button
                class="border-0 bg-transparent"
                name="close-eventos"
                onFocus={() => setModal(false)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
          <div class="body p-4">
            <div className="row">
              <div className="col-4 mb-2">
                <ul class="list-group p-1">
                  {eventos?.data?.columna1.map((evento) => (
                    <li className="list-group-item w-100 p-0 m-0 mb-1 border-0 bg-transparent">
                      <label className="btn btn-outline-dark w-100 text-start border-0">
                        {evento.nombre}
                        <button
                          className="d-none"
                          name="añadir-evento"
                          onClick={(e) => onClick(e, evento)}
                        ></button>
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="col-4 mb-2">
                <ul class="list-group p-1">
                  {eventos?.data?.columna2.map((evento) => (
                    <li className="list-group-item w-100 p-0 m-0 mb-1 border-0 bg-transparent">
                      <label className="btn btn-outline-dark w-100 text-start border-0">
                        {evento.nombre}
                        <button
                          className="d-none"
                          name="añadir-evento"
                          onClick={(e) => onClick(e, evento)}
                        ></button>
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="col-4 mb-2">
                <ul class="list-group p-1">
                  {eventos?.data?.columna3.map((evento) => (
                    <li className="list-group-item w-100 p-0 m-0 mb-1 border-0 bg-transparent">
                      <label className="btn btn-outline-dark w-100 text-start border-0">
                        {evento.nombre}
                        <button
                          className="d-none"
                          name="añadir-evento"
                          onClick={(e) => onClick(e, evento)}
                        ></button>
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="col-md-12">
                <div className="d-flex">
                  {eventos
                    ? eventos.links.map((link) => {
                        if (link.label == "&laquo; Previous") {
                          return (
                            <label
                              className={`btn btn-outline-dark ${
                                link.active ? "active" : ""
                              } ${link.url ? "" : "disabled"}`}
                            >
                              <i class="bi bi-arrow-left"></i>
                              <button
                                className="d-none"
                                onClick={() => {
                                  fetch(
                                    setEventos,
                                    {
                                      status: 1,
                                      sort: "-id",
                                      per_page: 50,
                                      page: eventos.current_page - 1,
                                    },
                                    `/eventos`
                                  );
                                }}
                              ></button>
                            </label>
                          );
                        }
                        if (link.label == "Next &raquo;") {
                          return (
                            <label
                              className={`btn btn-outline-dark ${
                                link.active ? "active" : ""
                              } ${link.url ? "" : "disabled"}`}
                            >
                              <i class="bi bi-arrow-right"></i>
                              <button
                                className="d-none"
                                onClick={() => {
                                  fetch(
                                    setEventos,
                                    {
                                      status: 1,
                                      sort: "-id",
                                      per_page: 50,
                                      page: eventos.current_page + 1,
                                    },
                                    `/eventos`
                                  );
                                }}
                              ></button>
                            </label>
                          );
                        }

                        return (
                          <label
                            className={`btn btn-outline-dark ${
                              link.active ? "active" : ""
                            } ${link.url ? "" : "disabled"}`}
                          >
                            {link.label}

                            <button
                              className="d-none"
                              onClick={() => {
                                fetch(
                                  setEventos,
                                  {
                                    status: 1,
                                    sort: "-id",
                                    per_page: 50,
                                    page: link.label,
                                  },
                                  `/eventos`
                                );
                              }}
                            ></button>
                          </label>
                        );
                      })
                    : ""}
                </div>
              </div>
            </div>
          </div>
          <div class="footer bg-white p-4">
            <div class="d-flex justify-content-between d-none">
              <div></div>
              <div>
                <button
                  class="btn btn-secondary rounded-pill px-4"
                  name="close"
                  onFocus={(event) => onClick(event)}
                >
                  Cancelar
                </button>
                <button
                  name="guardar"
                  onClick={(event) => onClick(event)}
                  className="ms-2 btn btn-custom-amarillo text-white"
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Eventos;
